export default __webpack_public_path__ + "static/media/6.ec9d3e6e.webp";